/**
 * Filter inputs
 */

$(function () {

    if ($('.only-numbers').length) {
        $('.only-numbers').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9]*$/.test(value);
            });
        });
    }
    if ($('.only-letters').length) {
        $('.only-letters').each(function () {
            setInputFilter(this, function (value) {
                return /^[a-zA-ZáéíóúÁÉÍÓÚ\'´ñÑäëïöüÄËÏÖÜ \-]*$/.test(value);
            });
        });
    }
    if ($('.only-alpha-numeric').length) {
        $('.only-alpha-numeric').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9a-zA-Z]*$/.test(value);
            });
        });
    }
    if ($('.only-phone').length) {
        $('.only-phone').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9\-]*$/.test(value);
            });
        });
        $('.only-phone').mask('000-000-0000');
    }

    if ($('.only-date').length) {
        $('.only-date').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9\/]*$/.test(value);
            });
        });
    }
});